import React from 'react';
import "../../../styles/global-hero.css";

const Hero = () => {
    return (
        <div className="global-hero">
            <div className="container text-center">
                <h1>Internal quality Assurance cell</h1>
                <p>Home &gt; IQAC &gt; Committee Letter</p>
            </div>
        </div>
    )
}

export default Hero;